import api from '../../services/api';
import { getCityAccessForBot } from './cityUtils';

const CITY_CONTEXT_TTL_MS = 10_000;

let cachedContext = null;
let cachedAt = 0;
let inFlightPromise = null;

function normalizeCityContext(data) {
  const bot = data?.bot || null;
  const city = data?.city || null;
  const transport = data?.transport || null;
  const rpg = data?.rpg || null;

  return {
    bot,
    city,
    transport,
    rpg,
    access: data?.access || getCityAccessForBot(bot, city)
  };
}

export function peekCityContextCache() {
  if (!cachedContext) return null;
  if (Date.now() - cachedAt > CITY_CONTEXT_TTL_MS) return null;
  return cachedContext;
}

export async function loadCityContext({ force = false } = {}) {
  const cached = peekCityContextCache();
  if (!force && cached) {
    return cached;
  }

  if (!force && inFlightPromise) {
    return inFlightPromise;
  }

  const requestPath = force
    ? `/robots/my-city-context?t=${Date.now()}`
    : '/robots/my-city-context';

  inFlightPromise = api.get(requestPath)
    .then((res) => {
      cachedContext = normalizeCityContext(res.data);
      cachedAt = Date.now();
      return cachedContext;
    })
    .finally(() => {
      inFlightPromise = null;
    });

  return inFlightPromise;
}

export function seedCityContextCache(context) {
  cachedContext = normalizeCityContext(context);
  cachedAt = Date.now();
}

export function clearCityContextCache() {
  cachedContext = null;
  cachedAt = 0;
  inFlightPromise = null;
}
